import { allocationCellKey } from '@ovComponents/4-module/widgets/portfolio/components/allocationCellKey';
import type { SubAccountCustomAllocationInput } from '@ovComponents/4-module/widgets/portfolio/components/buildCustomAllocationInput';
import { SolveStatuses } from '@ovComponents/4-module/widgets/portfolio/components/lockedMatrixRedistribute';
import { fractionToAmountCents } from '@utils/allocationUnits';
import type { CellEditPatch } from './resolveCellEdit';

export type SavedAllocationDraft = {
  matrix: SubAccountCustomAllocationInput[];
  lockedCells: string[];
};

// A saved matrix was a solved one (Continue needs an OK solve), so it comes
// back as solved: nothing waits on a Recalculate. Locks keep their cents the
// way a typed lock stores them. The saved matrix has no upload marks, so an
// uploaded cell returns as Locked.
export const restoredDraftPatch = (
  { matrix, lockedCells }: SavedAllocationDraft,
  mvCentsOf: (subAccountId: string) => number,
): CellEditPatch => {
  const lockedKeys = new Set(lockedCells);
  const draft = new Map<string, number>();
  const locks = new Map<string, number>();
  const lockCents = new Map<string, number>();

  for (const { subAccountId, overrides } of matrix) {
    for (const { financialProductId, customExpectedPercentage } of overrides) {
      const key = allocationCellKey(subAccountId, financialProductId);
      draft.set(key, customExpectedPercentage);
      if (!lockedKeys.has(key)) continue;
      locks.set(key, customExpectedPercentage);
      lockCents.set(
        key,
        fractionToAmountCents(
          customExpectedPercentage,
          mvCentsOf(subAccountId),
        ),
      );
    }
  }

  return {
    lockedCells: locks,
    lockedAmountCents: lockCents,
    uploadedCells: new Set(),
    draft,
    solveStatus: SolveStatuses.OK,
  };
};
